export default "__VITE_ASSET__0sDakNKt__"